import React from "react";
import { t } from "../../../utils/i18n";
const bcsuccess = require("../../../../assets/images/bcsuccess.gif");

const BCSuccess = () => {
  return (
    <div id="bcsuccess-cont">
      <div className="bcsuccess-section">
        <p className="bc-success">
          <img src={bcsuccess} alt={t("p2p.common.loader_alt")}/>
        </p>
      </div>
    </div>
  )
}

export default BCSuccess;
